import React from 'react';
import AuthForm from './auth-form.jsx';
import AuthShell from './auth-shell.jsx';

function AuthWithImageLockScreen() {
	return <AuthShell variant="with-image"><AuthForm variant="with-image" mode="lock-screen" /></AuthShell>;
}

export default AuthWithImageLockScreen;
